/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
 
export const SCROLL_VIEW_BOTTOM_DISTANCE_TO_SHOW_NEWEST_TIP = 600;
/**
 * 向下加载更多时，模拟 overflow anchor 效果，但是同时稍微移动视图内容，把新增内容稍微多展示一下
 */
export const LOAD_NEXT_ANCHOR_ADDITIONAL_MOVE_DISTANCE = 50;
export const LOAD_NEXT_LOCK_DELAY = 30;
